"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var finders_1 = require("./finders");
var utils_1 = require("./utils");
function setKeysFromPartial(target, arg) {
    [].concat(finders_1.findAllDotPaths(arg)).forEach(function (path) {
        return utils_1.setOnPath(target, path, utils_1.getValueFromString(arg, path));
    });
    return target;
}
exports.setKeysFromPartial = setKeysFromPartial;
//# sourceMappingURL=partials.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/util/partials.js
 ** module id = 2478
 ** module chunks = 0
 **/